// import schema
import { hourSchema } from '../../schema';

// import types
import { ResponseActionType } from 'generated/index';

// import utils
import * as yup from 'yup';
import { t } from 'i18next';

const booleanSchema = () =>
  yup.boolean().default(false).required(t('validation.valueIsRequired'));

const schema = yup.object().shape({
  minutesBeforeStart: hourSchema(),
  round: yup.object().shape({
    includeOwn: booleanSchema(),
    includeShared: booleanSchema(),
    includePreference1: booleanSchema(),
    includePreference2: booleanSchema(),
    includeFlexWithPreference1: booleanSchema(),
    includeFlexWithPreference2: booleanSchema(),
    includeFlex: booleanSchema(),
    includeDeployableAsFlexWithPreference1: booleanSchema(),
    includeDeployableAsFlexWithPreference2: booleanSchema(),
    includeDeployableAsFlex: booleanSchema(),
    responseActionType: yup.mixed<ResponseActionType>().default('CONNECT')
  })
});

export default schema;
